import React from 'react';
import clsx from 'clsx';
import PronounBadge from '../../../../../shared/PronounBadge';
import styles from './provider_block.module.scss';
import AppTooltip from '../../../../../components/shared/AppTooltip';

const ProviderMediaBlock = ({
  provider,
  bestMatch,
  stringValues,
  selectedSiteId,
  hasMultipleSites,
  selectedSite,
  changeSelectedSiteId,
  displayMatch = false,
  handlePatientPreference,
  disciplineEnabled = false,
}) => {
  const permittedActions = {
    hide: 'hide',
    unhide: 'unhide',
    like: 'like',
    dislike: 'dislike',
  };
  const handlePreferenceChange = (actition) => {
    handlePatientPreference({
      practitioner_id: provider.id,
      preferred_action: actition,
    });
  };
  return (
    <div className="media-block">
      <div className={`${styles.profPic} media-block__media`}>
        <div
          className="image"
          style={{ backgroundImage: `url(${provider.profile_pic_url})` }}
        />
      </div>
      <div className="media-block__content">
        <div className={`media-block ${styles.mediaDetail}`}>
          <div className={`media-block__content ${styles.mediaBlockWrap}`}>
            <div className={`d-flex justify-content-between align-items-end w-100 justify-between ${styles.mediaNameRow}`}>
              <h1 className={`${styles.mediaTitle} margin-bottom-0`}>
                {provider.name}
              </h1>

              <div className="d-flex justify-content-end align-items-end gap-15px">
                {provider.is_liked ? (
                  <div key={`fav-icon-container-${provider.is_hidden}`}>
                    <button
                      type="button"
                      className="d-flex tooltip-trigger btn-plain padding-0"
                      data-tip
                      data-for={`field-tooltip_${provider.id}_dislike`}
                      data-class={`field-tooltip_${provider.id}_dislike`}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePreferenceChange(permittedActions.dislike);
                      }}
                    >
                      <span
                        className={`material-symbols-outlined color-plum ${styles.starIcon} ${styles.filled}`}
                      >
                        star
                      </span>
                    </button>

                    <AppTooltip
                      id={`field-tooltip_${provider.id}_dislike`}
                      className={`field-tooltip_${provider.id}_dislike`}
                      place="top"
                      type="light"
                      borderColor="#cecece"
                      arrowColor="#fff"
                      delayShow={400}
                    >
                      Remove this provider from your favorites.
                    </AppTooltip>
                  </div>
                ) : (
                  <div key={`unfav-icon-container-${provider.is_hidden}`}>
                    <button
                      type="button"
                      className="d-flex btn-plain padding-0"
                      data-tip
                      data-for={`field-tooltip_${provider.id}_like`}
                      data-class={`field-tooltip_${provider.id}_like`}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePreferenceChange(permittedActions.like);
                      }}
                    >
                      <span
                        className={`material-symbols-outlined color-plum ${styles.starIcon}`}
                      >
                        star
                      </span>
                    </button>

                    <AppTooltip
                      id={`field-tooltip_${provider.id}_like`}
                      place="top"
                      type="light"
                      className={`field-tooltip_${provider.id}_like`}
                      borderColor="#cecece"
                      arrowColor="#fff"
                      delayShow={400}
                    >
                      Add this provider to your favorites.
                    </AppTooltip>
                  </div>
                )}
                {provider.is_hidden ? (
                  <div key={`diagonal-eye-icon-container-${provider.is_hidden}`}>
                    <button
                      type="button"
                      className={`d-flex btn-plain padding-0 ${styles.eyeIcon}`}
                      data-tip
                      data-for={`field-tooltip_${provider.id}_unhide`}
                      data-class={`field-tooltip_${provider.id}_unhide`}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePreferenceChange(permittedActions.unhide);
                      }}
                    >
                      <span className="material-icons-outlined color-plum">
                        visibility_off
                      </span>
                    </button>

                    <AppTooltip
                      id={`field-tooltip_${provider.id}_unhide`}
                      place="top"
                      type="light"
                      borderColor="#cecece"
                      className={`field-tooltip_${provider.id}_unhide`}
                      arrowColor="#fff"
                      delayShow={400}
                    >
                      Unhide this provider.
                    </AppTooltip>
                  </div>
                ) : (
                  <div key={`eye-icon-container-${provider.is_hidden}`}>
                    <button
                      type="button"
                      className={`d-flex btn-plain padding-0 ${styles.eyeIcon}`}
                      data-tip
                      data-for={`field-tooltip_${provider.id}_hide`}
                      data-class={`field-tooltip_${provider.id}_hide`}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePreferenceChange(permittedActions.hide);
                      }}
                    >
                      <span className="material-icons-outlined color-plum">
                        visibility
                      </span>
                    </button>

                    <AppTooltip
                      id={`field-tooltip_${provider.id}_hide`}
                      place="top"
                      type="light"
                      className={`field-tooltip_${provider.id}_hide`}
                      borderColor="#cecece"
                      arrowColor="#fff"
                      delayShow={400}
                    >
                      Hide this provider. You will be able to unhide them later.
                    </AppTooltip>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.mediaMeta}>
               {disciplineEnabled && provider?.discipline && (
                <div className={styles.discipline}>
                  {typeof provider.discipline === "object" && provider.discipline !== null
                    ? provider.discipline.name
                    : provider.discipline}
                </div>
              )}
              <div>{provider.suffix}</div>
              <div className="flex align-center">
                <span className="margin-right-sm">
                  {provider.sex &&
                    (typeof provider.sex === 'object'
                      ? provider.sex.name
                      : provider.sex)}
                </span>
                {provider.pronoun && (
                  <PronounBadge
                    pronoun={provider.pronoun}
                    theme="dark"
                    tooltipPlacement="bottom"
                  />
                )}
              </div>
            </div>
            <div className={styles.location}>
              {provider.sites_with_open_slots?.length > 1 && (
                <select
                  className={clsx('select-site', styles.locationSelect)}
                  value={selectedSiteId}
                  onChange={(e) => changeSelectedSiteId(e.target.value)}
                >
                  {provider.sites_with_open_slots.map((site) => (
                    <option
                      key={site.id}
                      value={site.id}
                      label={`Location: ${site.name}`}
                    >
                      {site.name}
                    </option>
                  ))}
                </select>
              )}
              {provider.intake_appt_role !== 'coordinator' &&
                (!hasMultipleSites
                  ? selectedSite
                    ? !selectedSite.hide_address &&
                      selectedSite.site_address_lines.join(', ')
                    : [provider.address_line_1, provider.address_line_2]
                        .filter((n) => n)
                        .join(', ')
                  : stringValues.multiple_locations_available)}
            </div>
            {
              // provider.phone_number is the slot site phone number, see CallCenter::ProviderListing#set_dfd_data
              !hasMultipleSites && (
                <div className={styles.mediaMeta}>
                  {selectedSite?.phone_number
                    ? selectedSite?.phone_number
                    : provider.phone_number}
                </div>
              )
            }
          </div>
          {displayMatch && (
            <div className={`${styles.matchWrap} media-block__media`}>
              <div className={styles.matchText}>
                {stringValues.match}:{' '}
                {provider.strength ? `${provider.strength}%` : 'N/A'}
              </div>
              {bestMatch && (
                <span className={styles.bestMatchPill}>
                  {stringValues.best_match}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProviderMediaBlock;
